/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import AbstractFlashMessages from "views/abstract/abstract_flash_messages";

export default class FlashMessages extends AbstractFlashMessages {}
